import { useAsyncEffect } from 'ahooks';
import { useState } from 'react';
import {
  checkpointDefMenu,
  defMenu,
  isMenuChoosed,
  hotRecommendList,
  loraDefMenu,
  modalType,
  quickModelShowType,
  isMenuOpened,
  hotModelsList,
  workFlowMenu,
} from '../../constants';
import { requestByGet } from '@shakkerai/services';

const dealQuickSaw = ({ id, code, tagLabel, featureCates = [] }, type) => {
  if (id === defMenu.hotRecommendId) {
    if (type === modalType.WORKFLOW) {
      return hotQuickAppList;
    } else {
      return hotModelsList;
    }
  }
  if (id === defMenu.collectModelId || id === defMenu.historyModelId || id === defMenu.hotRecommendId) {
    return []; // 本地扩展
  }
  return featureCates.concat([
    {
      type: quickModelShowType.appendTagCode,
      label: `浏览全部优质${tagLabel}模型`,
      code,
    },
  ]);
};

const formatMenuList = (list, type) => {
  return list.map((l) => ({
    ...l,
    open: isMenuOpened(type, l),
    level: 0,
    collectionId: l.id === defMenu.hotRecommendId ? '1' : l.collectionId, // 热门精选
    choosed: isMenuChoosed(type, l.id),
    featureCates: dealQuickSaw(l),
    children: [],
    children: l.children
      ? l.children.map((ll) => ({
          ...ll,
          open: false,
          choosed: isMenuChoosed(type, ll.id),
          level: 1,
          children: ll.children
            ? ll.children.map((lll) => ({
                ...lll,
                open: false,
                choosed: false,
                level: 2,
                children: null,
              }))
            : null,
        }))
      : null,
  }));
};
export const useMenu = (type) => {
  const [menuList, setMenuList] = useState([]);
  useAsyncEffect(async () => {
    try {
      if (type === modalType.WORKFLOW) {
        setMenuList(formatMenuList(workFlowMenu, type));
      } else {
        const res = await requestByGet(`/api/canva/public/v3/tag/list?modelType=${type}`);
        const dyncMenu = eval(res.data) ?? [];
        if (type === modalType.CHECKPOINT) {
          setMenuList(formatMenuList(checkpointDefMenu.concat(dyncMenu), type));
        }
        if (type === modalType.LORA) {
          setMenuList(formatMenuList(loraDefMenu.concat(dyncMenu), type));
        }
      }
    } catch (err) {
      console.log('模型库菜单栏接口异常', err);
    }
  }, []);
  return menuList;
};
